import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};

const setOeeEquipment = (state, { oeeEquipmentData }) => {
  if (!oeeEquipmentData) return state;
  return state.merge({ oeeEquipmentData });
};

const setToolCavityTable = (state, { toolCavityTable }) => {
  if (!toolCavityTable) return state;
  return state.merge({ toolCavityTable });
};

const setEquipmentTrends = (state, { equipmentTrends }) => {
  if (!equipmentTrends) return state;
  return state.merge({ equipmentTrends });
};

const setAssemblyEquipmentTrends = (state, { equipmentTrends }) => {
  if (!equipmentTrends) return state;
  return state.merge({ equipmentTrends });
};

const setTrendCycleLoader = (state, { showTrendCycleLoader }) => {
  return state.merge({ showTrendCycleLoader });
};
export const callbacks = [
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
  {
    actionType: ActionTypes.SET_OEE_EQUIPMENT,
    actionFunction: setOeeEquipment,
  },
  {
    actionType: ActionTypes.SET_TOOL_CAVITY_TABLE,
    actionFunction: setToolCavityTable,
  },
  {
    actionType: ActionTypes.SET_EQUIPMENT_TRENDS,
    actionFunction: setEquipmentTrends,
  },
  {
    actionType: ActionTypes.SET_ASSEMBLY_EQUIPMENT_TRENDS,
    actionFunction: setAssemblyEquipmentTrends,
  },
  {
    actionType: ActionTypes.SET_TREND_CYCLE_LOADER_STATUS,
    actionFunction: setTrendCycleLoader,
  },
];
